import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLCapitalizeStringFilter } from 'ml-portals-util-js';
import { MLPolicyChangeDataHolderService } from 'ml-services-common-react';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';

import messages from './MLReasonComponent.messages';
import metadata from './MLReasonComponent.metadata.json5';

const MLReasonComponent = (props) => {
    const {
        driver,
        removeAction,
        onValidate,
        showValidationErrors,
        viewModelService,
        translator,
        isModernProduct
    } = props;

    const { refreshData } = useDataRefresh();
    const statusTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');

    const {
        getDriverNotListedReasonsForAdding,
        getRemoveDriverExcludedOptions
    } = MLDriverVehicleUtil();

    const getHouseholdMemberReasonLabel = () => {
        if (removeAction) {
            return translator(messages.reasonForRemovingName, {
                name: MLCapitalizeStringFilter.capitalize(_.get(driver, 'displayName.value'))
            });
        }
        return translator(messages.reasonNotListed);
    };

    const getReasons = () => {
        const driverType = MLPolicyChangeDataHolderService.getDriverType();
        return getDriverNotListedReasonsForAdding(driverType, isModernProduct);
    };

    const getHouseholdMemberTypeOptions = () => {
        let codes = statusTypelist.codes.filter((status) => {
            if(isModernProduct) {
                 return _.includes(getReasons(), status.code) && status.code !== "never_licensed"
            }
            return _.includes(getReasons(), status.code)
        });
        const excludedForLegacy = new Set(["unabletodrive", "registeredowner"]);
        const excludedForModern = new Set(["never_licensed"]);
        
        if (removeAction) {
            codes = statusTypelist.codes;
            if (isModernProduct) {
                codes = codes.filter(
                    (status) => !excludedForModern.has(status.code)
                );
            } else {
                codes = codes.filter(
                    (status) => !excludedForLegacy.has(status.code)
                );
            }
        }
        return codes.map((option) => {
            return {
                code: option.code,
                name: translator({
                    id: option.name,
                    defaultMessage: option.name
                })
            };
        });
    };

    const updateDriverVM = () => {
        refreshData();
    };

    const overrideProps = {
        reasonRow: {
            className: removeAction ? classNames('row', 'vertical-spacing-20', 'col-md-12') : classNames('row', 'vertical-spacing-40', 'col-md-12')
        },
        reason: {
            label: getHouseholdMemberReasonLabel(),
            availableValues: getHouseholdMemberTypeOptions()
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={driver}
            overrideProps={overrideProps}
            onModelChange={updateDriverVM}
            onValidationChange={onValidate}
            showErrors={showValidationErrors}
        />
    );
};

MLReasonComponent.propTypes = {
    driver: PropTypes.object.isRequired,
    removeAction: PropTypes.bool,
    showValidationErrors: PropTypes.bool,
    viewModelService: PropTypes.object.isRequired,
    translator: PropTypes.func.isRequired,
    isModernProduct: PropTypes.bool
};

MLReasonComponent.defaultProps = {
    removeAction: false,
    showValidationErrors: false,
    isModernProduct: false
};

export default MLReasonComponent;
